<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";

const controlComponent = defineAsyncComponent(() => import('@common/control/control.vue'));

const editorSettings = {};

const udfDetailsPanelConfig = {
    cId: "udfDetailsPanel",
    cType: "udfDetailsPanel",
    cTitle: "UDF Details Panel",
    cTemplate: `<div>
                    <control name="SHOW_CA_INFO" :prop-config="controlConfig['SHOW_CA_INFO']" :label="codeId"></control>
                </div>`,
    controls: [
        {
            name: 'SHOW_CA_INFO',
            type: 'button',
            onclick: 'showInfo',
            cssClass: "e-link udf-details-panel"
        },
        {
            name: 'CA_NAME',
            label: 'Name',
            type: 'string',
        },
        {
            name: 'CA_CODE',
            label: 'Code ID',
            type: 'string',
        },
        {
            name: 'CA_LABEL',
            label: 'Label',
            type: 'string',
        },
        {
            name: 'CA_DESCRIPTION',
            label: 'Description',
            type: 'text',
        },
        {
            name: 'typeName',
            label: 'Type',
            type: 'text',
            asField: true,
        },
        {
            name: 'CA_IS_REQUIRED',
            label: 'Required',
            type: 'boolean',
        },
        {
            name: 'CA_IS_SECURE',
            label: 'Secure',
            type: 'boolean',
        },
        {
            name: 'CA_ID',
            label: 'ID',
            type: 'text',
            asField: true,
        },
        {
            name: 'CA_SKIP_ON_TAB',
            label: 'Do not show on UDF tab of the profile',
            type: 'boolean',
        },
        {
            name: 'CA_GROUP_NAME',
            label: 'Group Name',
            type: 'text',
            asField: true,
        },
        {
            name: 'CA_GROUP_ID',
            label: 'Group ID',
            type: 'text',
            asField: true,
        },
        {
            name: 'CA_TYPE',
            label: 'Group Type',
            type: 'text',
            asField: true,
        },
        {
            name: 'CA_ACCESS_MODE',
            label: 'Visibility',
            label0: 'Any other eCoordinator account can see this field.',
            label1: 'Other eCoordinator accounts cannot see this field',
            type: 'radio_button_list',
            items: [
                { label: 'Any other eCoordinator account can see this field.', value: '0' },
                { label: 'Other eCoordinator accounts cannot see this field', value: '1' },
            ],
        },
        {
            name: 'CA_GUID',
            label: 'GUID',
            type: 'text',
            asField: true,
        },
        {
            name: 'CA_GROUP_PERSPEC',
            label: 'Perspective',
            type: 'text',
            asField: true,
        },
        {
            name: 'ALLOWED_EXT',
            label: 'Max allowed attachment size: 10 MB',
            type: 'radio_button_list',
            items: [
                { label: 'Allow only following attachment extensions (defined in Administrative Options, on General tab): doc, docx, jpg, jpeg, png, gif, otf, pdf, csv', value: '0' },
                { label: 'Define list specific for this UDF ', value: '1' },
            ],
        },
        {
            name: 'ALLOWED_EXT_LIST',
            type: 'string',
        },
        {
            name: 'CA_MODIFY_DATES',
            label: 'Enable date stamps for this field',
            type: 'boolean',
        },
        {
            name: 'CA_MULTISELECT',
            label: 'Allow multiple selections',
            type: 'boolean',
        },
        {
            name: 'CA_DECIMAL_PLACE',
            label: 'Decimal Places',
            type: 'number',
        },
        {
            name: 'CA_PREFIX',
            label: 'Prefix',
            type: 'string',
        },
        {
            name: 'CA_DEFAULT_VALUE',
            label: 'Initial value',
            type: 'string',
        },
        {
            name: 'CA_POSTFIX',
            label: 'Postfix',
            type: 'string',
        },
        {
            name: 'CA_PADDING',
            label: 'Zero fill to (digits)',
            type: 'number',
        },
        {
            name: 'CA_WIDTH',
            label: 'Width',
            type: 'number',
        },
        {
            name: 'CA_HEIGHT',
            label: 'Height (rows)',
            type: 'number',
        },
        {
            name: 'CA_NO_DEFAULT',
            label: 'No Default',
            type: 'boolean',
        },
        {
            name: 'CURRENCY_SYMB',
            label: 'Currency Symbol',
            type: 'string',
        },
        {
            name: 'CA_FORMAT',
            label: 'Format',
            type: 'dropdown',
            items: [
                {
                    text: '12 Hour', value: 1
                },
                {
                    text: '24 Hour', value: 2
                }
            ],
            fields: { text: 'text', value: 'value' },
        },
        {
            name: 'CA_DEFAULT_LTEXT',
            label: 'URL',
            type: 'string',
        },
        {
            name: 'CA_DEFAULT_TEXT',
            label: 'Text value',
            type: 'string',
        }
    ]
};

const udfDetailsPanelCmp = {
    name: "udfDetailsPanel",
    editorSettings: editorSettings,
    props: {
        codeId: {
            required: true
        }
    },
    data() {
        return {
            caInfo: false,
            controlConfig: {}
        };
    },
    methods: {
        prepareProperties(props) {
            let remove = ['UDFkey', 'isEditable', ''];
            for (let i in props) {
                if (i === 'length') continue;
                if (remove.indexOf(i) !== -1) delete props[i];
                if (i === 'typeName') props[i] = library.capitalizeFirstLetter(props[i].toLowerCase());
                if (i === 'CA_ACCESS_MODE') props[i] += '';
                if (i === 'ALLOWED_EXT') {
                    props['ALLOWED_EXT_LIST'] = props[i];
                    props[i] = props[i].trim().length ? '1' : '0';
                }
            }
            return props;
        },
        showInfo() {
            let self = this;
            this.sDs.post('sds_getUdfList', false, false, [this.codeId], true).then((response) => {
                if (response.status === 'success') {
                    for (let i in response.data) {
                        if (i === 'length') continue;
                        if (response.data[i] && response.data[i].CA_CODE === self.codeId) {
                            self.caInfo = this.prepareProperties(response.data[i]);
                            break;
                        }
                    }
                    if (self.caInfo) {
                        let controlConfig = library.cloneObj(this.controls);
                        let caInfoTemplate = {
                            name: "ca-info-template",
                            template: `<div v-if="caInfo">
                                            <div v-if="!editMode">
                                                <ul class="simple-details-list">
                                                    <li>Name: {{caInfo['CA_NAME']}}</li>
                                                    <li>Code ID: {{caInfo['CA_CODE']}}</li>
                                                    <li>Type: {{caInfo['typeName']}}</li>
                                                    <li>Required: {{caInfo['CA_IS_REQUIRED'] === 1 ? 'true' : 'false'}}</li>
                                                    <li>Secure: {{caInfo['CA_IS_SECURE'] === 1 ? 'true' : 'false'}}</li>
                                                    <li>Description: {{caInfo['CA_DESCRIPTION']}}</li>
                                                    <li>Access Mode:  {{caInfo['CA_ACCESS_MODE']}}</li>
                                                </ul>
                                                <ejs-button v-on:click="showDetails()" type="button">
                                                    Full Details
                                                </ejs-button>
                                            </div>
                                            <div v-if="editMode">
                                                <div class="half"><control name="CA_NAME" :prop-config="controlConfig['CA_NAME']" :value="caInfo['CA_NAME']" :disabled="true"></control></div>
                                                <div class="half"><control name="CA_CODE" :prop-config="controlConfig['CA_CODE']" :value="caInfo['CA_CODE']" :disabled="true"></control></div>
                                                <div class="clearfix"></div>
                                                <control name="CA_LABEL" :prop-config="controlConfig['CA_LABEL']" :value="caInfo['CA_LABEL']" :disabled="true"></control>
                                                <control name="CA_DESCRIPTION" :prop-config="controlConfig['CA_DESCRIPTION']" :value="caInfo['CA_DESCRIPTION']" :disabled="true"></control>
                                                <div class="half">
                                                    <div class="half">
                                                        <control name="typeName" :prop-config="controlConfig['typeName']" :value="caInfo['typeName']" :disabled="true"></control>
                                                        <control name="CA_ID" :prop-config="controlConfig['CA_ID']" :value="caInfo['CA_ID']" :disabled="true"></control>
                                                    </div>
                                                    <div class="half">
                                                        <control name="CA_IS_REQUIRED" :prop-config="controlConfig['CA_IS_REQUIRED']" :value="caInfo['CA_IS_REQUIRED']" :disabled="true"></control>
                                                        <control name="CA_IS_SECURE" :prop-config="controlConfig['CA_IS_SECURE']" :value="caInfo['CA_IS_SECURE']" :disabled="true"></control>
                                                    </div>
                                                </div>
                                                <div class="half"><control name="CA_ACCESS_MODE" :prop-config="controlConfig['CA_ACCESS_MODE']" :value="caInfo['CA_ACCESS_MODE']" :disabled="true"></control></div>
                                                <div class="clearfix"></div>
                                                <div v-if="caInfo['CA_TYPE'] === 14">
                                                    <control name="ALLOWED_EXT" :prop-config="controlConfig['ALLOWED_EXT']" :value="caInfo['ALLOWED_EXT']" :disabled="true"></control>
                                                    <control name="ALLOWED_EXT_LIST" :prop-config="controlConfig['ALLOWED_EXT_LIST']" :value="caInfo['ALLOWED_EXT_LIST']" :disabled="true"></control>
                                                </div>
                                                <div v-if="caInfo['CA_TYPE'] === 5 || caInfo['CA_TYPE'] === 17 || caInfo['CA_TYPE'] === 9">
                                                    <table id="ListType" cellspacing="1" cellpadding="3">
                                                        <thead>
                                                        <tr>
                                                            <th class="listype-header">Choice</th>
                                                            <th v-if="caInfo['CA_TYPE'] === 9" class="listype-header">Value</th>
                                                            <th v-if="caInfo['CA_TYPE'] === 5 || caInfo['CA_TYPE'] === 9" class="listype-header">Default Selection</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="(prop, index) in caInfo['listValues']" :key="index">
                                                            <td> {{caInfo['listValues'][index]['VALUE']}} </td>
                                                            <td v-if="caInfo['CA_TYPE'] === 9"> {{caInfo['listValues'][index]['VALUE']}} </td>
                                                            <td v-if="caInfo['CA_TYPE'] === 5"> {{caInfo['listValues'][index]['VALUE_SELECT']}} </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                    <control name="CA_MULTISELECT" :prop-config="controlConfig['CA_MULTISELECT']" :value="caInfo['CA_MULTISELECT']" :disabled="true"></control>
                                                    <control v-if="caInfo['CA_TYPE'] === 17" name="CA_DECIMAL_PLACE" :prop-config="controlConfig['CA_DECIMAL_PLACE']" :value="caInfo['CA_DECIMAL_PLACE']" :disabled="true"></control>
                                                </div>
                                                <div v-if="caInfo['CA_TYPE'] === 13">
                                                    <div class="clearfix"></div>
                                                    <div class="half">
                                                        <div class="quarter"><control name="CA_PREFIX" :prop-config="controlConfig['CA_PREFIX']" :value="caInfo['CA_PREFIX']" :disabled="true"></control></div>
                                                        <div class="half"><control name="CA_DEFAULT_VALUE" :prop-config="controlConfig['CA_DEFAULT_VALUE']" :value="caInfo['CA_DEFAULT_VALUE']" :disabled="true"></control></div>
                                                        <div class="quarter"><control name="CA_POSTFIX" :prop-config="controlConfig['CA_POSTFIX']" :value="caInfo['CA_POSTFIX']" :disabled="true"></control></div>
                                                    </div>
                                                    <div class="half"><control name="CA_PADDING" :prop-config="controlConfig['CA_PADDING']" :value="caInfo['CA_PADDING']" :disabled="true"></control></div>
                                                    <div class="clearfix"></div>
                                                </div>
                                                <div v-if="caInfo['CA_TYPE'] === 2">
                                                    <control name="CA_WIDTH" :prop-config="controlConfig['CA_WIDTH']" :value="caInfo['CA_WIDTH']" :disabled="true"></control>
                                                    <control name="CA_HEIGHT" :prop-config="controlConfig['CA_HEIGHT']" :value="caInfo['CA_HEIGHT']" :disabled="true"></control>
                                                    <control name="CA_NO_DEFAULT" :prop-config="controlConfig['CA_NO_DEFAULT']" :value="caInfo['CA_NO_DEFAULT']" :disabled="true"></control>
                                                    <control name="CA_DEFAULT_VALUE" :prop-config="controlConfig['CA_DEFAULT_VALUE']" :value="caInfo['CA_DEFAULT_VALUE']" :disabled="true"></control>
                                                </div>
                                                <div v-if="caInfo['CA_TYPE'] === 1 || caInfo['CA_TYPE'] === 16">
                                                    <control name="CA_DECIMAL_PLACE" :prop-config="controlConfig['CA_DECIMAL_PLACE']" :value="caInfo['CA_DECIMAL_PLACE']" :disabled="true"></control>
                                                    <control name="CA_WIDTH" :prop-config="controlConfig['CA_WIDTH']" :value="caInfo['CA_WIDTH']" :disabled="true"></control>
                                                    <control v-if="caInfo['CA_TYPE'] === 1" name="CURRENCY_SYMB" :prop-config="controlConfig['CURRENCY_SYMB']" :value="caInfo['CURRENCY_SYMB']" :disabled="true"></control>
                                                    <div class="clearfix"></div>
                                                    <div class="half"><control name="CA_NO_DEFAULT" :prop-config="controlConfig['CA_NO_DEFAULT']" :value="caInfo['CA_NO_DEFAULT']" :disabled="true"></control></div>
                                                    <div class="half"><control name="CA_DEFAULT_VALUE" :prop-config="controlConfig['CA_DEFAULT_VALUE']" :value="caInfo['CA_DEFAULT_VALUE']" :disabled="true"></control></div>
                                                    <div class="clearfix"></div>
                                                </div>
                                                <div v-if="caInfo['CA_TYPE'] === 8">
                                                    <control name="CA_WIDTH" :prop-config="controlConfig['CA_WIDTH']" :value="caInfo['CA_WIDTH']" :disabled="true"></control>
                                                    <control name="CA_HEIGHT" :prop-config="controlConfig['CA_HEIGHT']" :value="caInfo['CA_HEIGHT']" :disabled="true"></control>
                                                    <div class="clearfix"></div>
                                                    <div class="half"><control name="CA_NO_DEFAULT" :prop-config="controlConfig['CA_NO_DEFAULT']" :value="caInfo['CA_NO_DEFAULT']" :disabled="true"></control></div>
                                                    <div class="half"><control name="CA_DEFAULT_VALUE" :prop-config="controlConfig['CA_DEFAULT_VALUE']" :value="caInfo['CA_DEFAULT_VALUE']" :disabled="true"></control></div>
                                                    <div class="clearfix"></div>
                                                </div>
                                                <div v-if="caInfo['CA_TYPE'] === 4">
                                                    <control name="CA_FORMAT" :prop-config="controlConfig['CA_FORMAT']" :value="caInfo['CA_FORMAT']" :disabled="true"></control>
                                                    <div class="clearfix"></div>
                                                    <div class="half"><control name="CA_NO_DEFAULT" :prop-config="controlConfig['CA_NO_DEFAULT']" :value="caInfo['CA_NO_DEFAULT']" :disabled="true"></control></div>
                                                    <div class="half"><control name="CA_DEFAULT_VALUE" :prop-config="controlConfig['CA_DEFAULT_VALUE']" :value="caInfo['CA_DEFAULT_VALUE']" :disabled="true"></control></div>
                                                    <div class="clearfix"></div>
                                                </div>
                                                <div v-if="caInfo['CA_TYPE'] === 10">
                                                    <control name="CA_DEFAULT_TEXT" :prop-config="controlConfig['CA_DEFAULT_TEXT']" :value="caInfo['CA_DEFAULT_TEXT']" :disabled="true"></control>
                                                    <control name="CA_DEFAULT_LTEXT" :prop-config="controlConfig['CA_DEFAULT_LTEXT']" :value="caInfo['CA_DEFAULT_LTEXT']" :disabled="true"></control>
                                                </div>
                                                <control name="CA_SKIP_ON_TAB" :prop-config="controlConfig['CA_SKIP_ON_TAB']" :value="caInfo['CA_SKIP_ON_TAB']" :disabled="true"></control>
                                                <control name="CA_MODIFY_DATES" :prop-config="controlConfig['CA_MODIFY_DATES']" :value="caInfo['CA_MODIFY_DATES']" :disabled="true"></control>
                                            </div>
                                        </div>
                            `,
                            data() {
                                return {
                                    caInfo: self.caInfo,
                                    controlConfig: controlConfig,
                                    editMode: false
                                };
                            },
                            methods: {
                                showDetails() {
                                    this.editMode = !this.editMode;
                                }
                            },
                            components: {
                                control: controlComponent
                            }
                        };
                        library.showDialog(caInfoTemplate, false, false, { title: 'Edit Current User Defined Field', cssClass: 'ca-info-template' });
                    }
                }
            });
        }
    },
    components: {
        "ejs-button": defineAsyncComponent(() => import('@common/syncfusion/button')),
    },
};

componentStore.initComponent(udfDetailsPanelCmp, udfDetailsPanelConfig, '@common/udfDetailsPanel.vue');

export default udfDetailsPanelCmp;
</script>

<style scoped>
    .half {
        display: block;
        width: 48%;
        float: left;
        margin: 0 1%;
    }

    :deep(.checkbox-list-input) {
        margin-top: 0px;
    }
    :deep(.e-link.udf-details-panel) {
        padding: 0 !important;
        border-bottom: 1px dotted #ddd !important;
        width: auto;
        text-transform: none;
        display: inline-block;
    }
</style>
<style>
    .ca-info-template .simple-details-list {
        list-style: none;
        border: 1px solid #ccc;
    }
    .ca-info-template .simple-details-list li {
        padding: 5px;
        background: #f0f0f0;
        border-bottom: #ccc;
    }
    .ca-info-template .simple-details-list li:nth-child(odd) {
        background: #fff;
    }
    .ca-info-template .half {
        display: block;
        width: 48%;
        float: left;
        margin: 0 1%;
    }

    .ca-info-template .quarter {
        display: block;
        width: 23%;
        float: left;
        margin: 0 1%;
    }

    .ca-info-template .checkbox-list-input {
        margin-top: 0px;
    }

    .ca-info-template .listype-header {
        background-color: #cfd8dc;
        font-size: 13px;
    }

    .ca-info-template #ListType {
        margin-bottom: 20px;
        margin-top: 5px;
        border: 1px solid #bdbdbd;
        width: 100%;
    }

    .ca-info-template #ListType tr {
        height: 40px;
    }
</style>
